import { render } from "./MultipleChoiceField.vue?vue&type=template&id=dbebe400&scoped=true"
import script from "./MultipleChoiceField.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceField.vue?vue&type=script&lang=js"

import "./MultipleChoiceField.vue?vue&type=style&index=0&id=dbebe400&scoped=true&lang=css"

import exportComponent from "c:\\Clients\\VoterFly\\application\\VoterFly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbebe400"]])

export default __exports__